import { __ } from '@web-stories-wp/i18n';
import { SimplePanel } from '../../panel';
import BackdropControls from '../textBox/backdrop';

export default function BackgroundBlurPanel(props) {
  return (
    <SimplePanel
      name="backgroundBlur"
      title={__('Background blur', 'web-stories')}
      isPersistable
    >
      <BackdropControls {...props} isElementBackdrop />
    </SimplePanel>
  );
}
